<mits-header [title]="pageTitle" [defaultHref]="'/checklists'">
</mits-header>
<ion-content>
  <ion-segment *ngIf="object" [(ngModel)]="editLang" [ngModelOptions]="{ standalone: true }" scrollable>
    <ion-segment-button *ngFor="let lang of languages" [value]="lang.languageCode">
      <ion-label>{{ lang.language }}</ion-label>
    </ion-segment-button>
  </ion-segment>
  <ion-grid *ngIf="object">
    <ion-row>
      <ion-col size="4" sizeSm="4" sizeMd="2.5" sizeLg="2.5">
        <checklist-navigation [name]="object.name" [groups]="object.groups" [(selected)]="selected">
        </checklist-navigation>
      </ion-col>
      <ion-col size="8" sizeSm="8" sizeMd="9.5" sizeLg="9.5">
        <ion-card [ngClass]="{'core': deviceTypes.desktop, 'apple': deviceTypes.ios,  'android': deviceTypes.android}">
          <ion-card-title i18n>
            Einstellungen
            <span class="cardHeaderButton">
              <mits-icon name="info"></mits-icon>
            </span>
          </ion-card-title>
          <ion-card-content>
            <ion-grid *ngIf="!selected">
              <ion-row>
                <ion-col size="12">
                  <ion-card-subtitle i18n>Checkliste</ion-card-subtitle>
                  <span class="settingsGroupWrapper">
                    <ion-item>
                      <ion-label position="floating" i18n>Name</ion-label>
                      <ion-input [ngModel]="fieldText(object, 'name')" (ngModelChange)="setFieldText(object, 'name', $event)"></ion-input>
                    </ion-item>
                    <ion-item *ngIf="resourceAssotiations.length > 0">
                      <ion-label position="floating" i18n>Datentyp</ion-label>
                      <ion-select interface="popover" [(ngModel)]="object.resource">
                        <ion-select-option *ngFor="let attribute of resourceAssotiations" [value]="attribute.type">
                          {{attribute.display}}
                        </ion-select-option>
                      </ion-select>
                    </ion-item>
                    <ion-item lines="none">
                      <ion-label i18n>Aktiviert / Zur Benutzung freigegeben</ion-label>
                      <ion-toggle slot="end" [(ngModel)]="object.active"></ion-toggle>
                    </ion-item>
                    <ion-item lines="none">
                      <ion-label i18n>Checkliste vor Abschluss bestätigen</ion-label>
                      <ion-toggle slot="end" [(ngModel)]="object.require_finish"></ion-toggle>
                    </ion-item>
                    <ion-item lines="none">
                      <ion-label i18n>Kundennummer unter Unterschrift (Auftragsgeber) vorausfüllen</ion-label>
                      <ion-toggle slot="end" [(ngModel)]="object.require_customer_number"></ion-toggle>
                    </ion-item>
                    <ion-item lines="none">
                      <ion-label i18n>Unterschrift Kunde notwendig?</ion-label>
                      <ion-toggle slot="end" [(ngModel)]="object.require_signature_customer"></ion-toggle>
                    </ion-item>
                    <ion-item lines="none">
                      <ion-label i18n>Unterschrift Mitarbeiter notwendig?</ion-label>
                      <ion-toggle slot="end" [(ngModel)]="object.require_signature_service_worker"></ion-toggle>
                    </ion-item>
                  </span>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12">
                  <ion-card-subtitle i18n>Aktionen</ion-card-subtitle>
                  <span class="bigWithOptionButton">
                    <ion-button expand="block" color="primary" (click)="exportChecklist()" i18n>
                      Checkliste exportieren
                    </ion-button>
                    <ion-button expand="block" color="primary" (click)="openExportOptions($event)">
                      <ion-icon name="options-outline" slot="icon-only"></ion-icon>
                    </ion-button>
                  </span>
                </ion-col>
              </ion-row>
            </ion-grid>
            <ion-grid *ngIf="selected?.item">
              <ion-row>
                <ion-col size="12" *ngIf="!isSelectedType('IChecklistDependency')">
                  <ion-card-subtitle i18n>Grundlegend</ion-card-subtitle>
                  <span class="settingsGroupWrapper">
                    <ion-item>
                      <ion-label position="floating">Titel</ion-label>
                      <ion-input [ngModel]="fieldText(selected.item, 'title')" (ngModelChange)="setFieldText(selected.item, 'title', $event)">
                      </ion-input>
                    </ion-item>
                    <ion-item
                      *ngIf="isSelectedType('IChecklistModule') && selected.item['type'] != 'ChecklistManagement::Modules::BooleanModule'">
                      <ion-label i18n>Pflichtfeld</ion-label>
                      <ion-checkbox [(ngModel)]="selected.item['required']"></ion-checkbox>
                    </ion-item>
                  </span>
                </ion-col>
                <ion-col size="12" sizeMd="6" *ngIf="!isSelectedType('IChecklistGroup')">
                  <ion-card-subtitle i18n>Element</ion-card-subtitle>
                  <span class="settingsGroupWrapper">
                    <ion-item *ngIf="isSelectedType('IChecklistModule')">
                      <ion-label position="floating" i18n>Elementtyp</ion-label>
                      <ion-select [(ngModel)]="selected.item['type']" (ngModelChange)="changedElementType($event)"
                        interface="popover">
                        <ion-select-option *ngFor="let typeAsso of typeAssotiations" [value]="typeAsso.type">
                          {{typeAsso.display}}
                        </ion-select-option>
                      </ion-select>
                    </ion-item>
                    <ion-item *ngIf="isSelectedType('IChecklistDependency')">
                      <ion-label position="floating" i18n>RegEx-Ausdruck</ion-label>
                      <ion-input [(ngModel)]="selected.item['value']">
                      </ion-input>
                    </ion-item>
                    <checklist-default-value [checklistModule]="selected.item"
                      *ngIf="selected.item['type'] !== 'ChecklistManagement::Modules::GalleryModule' && selected.item['type'] !== 'ChecklistManagement::Modules::DateModule'">
                    </checklist-default-value>
                    <settings-select-element [selected]="selected"
                      *ngIf="selected.item['type'] === 'ChecklistManagement::Modules::SelectModule'">
                    </settings-select-element>
                    <settings-number-element [selected]="selected"
                      *ngIf="selected.item['type'] === 'ChecklistManagement::Modules::NumberModule'">
                    </settings-number-element>
                  </span>
                </ion-col>
                <ion-col size="12" sizeMd="6"
                  *ngIf="isSelectedType('IChecklistModule') && (shouldShow('placeholder') || shouldShow('description'))">
                  <ion-card-subtitle i18n>Zusätzlich</ion-card-subtitle>
                  <span class="settingsGroupWrapper">
                    <ion-item *ngIf="shouldShow('placeholder')">
                      <ion-label position="floating" i18n>Platzhalter</ion-label>
                      <ion-input [ngModel]="fieldText(selected.item, 'placeholder')" (ngModelChange)="setFieldText(selected.item, 'placeholder', $event)">
                      </ion-input>
                    </ion-item>
                    <ion-item *ngIf="shouldShow('description')">
                      <ion-label position="floating" i18n>Beschreibung</ion-label>
                      <ion-textarea [ngModel]="fieldText(selected.item, 'description')" (ngModelChange)="setFieldText(selected.item, 'description', $event)">
                      </ion-textarea>
                    </ion-item>
                  </span>
                </ion-col>
                <ion-col size="12" sizeMd="6" *ngIf="isSelectedType('IChecklistDependency')">
                  <ion-card-subtitle i18n>RegEx - Vorlagen</ion-card-subtitle>
                  <span class="settingsGroupWrapper">
                    <ion-list>
                      <ion-item button detail="true" *ngFor="let regexExample of regexAssotiations"
                        (click)="selected.item['value'] = regexExample.regex">
                        {{regexExample.display}}
                      </ion-item>
                    </ion-list>
                  </span>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-row>
    <ion-col>
      <ion-button expand="block" color="primary" (click)="saveChecklist()" i18n>
        Checkliste speichern
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>